export default {
 	user: state =>state.user,
  logged: state => state.logged,
  menu: state => state.menu,
  apiToken: state => state.apiToken,
}
